import { Chat, MessageQuery } from 'types/chat';

export function syncDraftWithRequest(draft: Chat, body: MessageQuery) {
  draft.mode = body.expertise;

  const existingByKey = new Map(
    draft.models.map(
      (model) => [`${model.id}:${model.expertRole}`, model] as const,
    ),
  );

  const requested: Array<{
    id: string;
    expertRole: 'summary' | 'expert';
    order: number;
  }> = [];

  // if (body.expertise === 'single') {
  //   requested.push({
  //     id: body.expertModes[0] ?? draft.models[0]?.id ?? 'default',
  //     expertRole: 'expert',
  //     order: 1,
  //   });
  // } else {
  if (body.summaryMode) {
    requested.push({
      id: body.summaryMode,
      expertRole: 'summary',
      order: 1,
    });
  }

  body.expertModes.forEach((id) => {
    requested.push({
      id,
      expertRole: 'expert',
      order: requested.length + 1,
    });
  });
  // }

  draft.models = requested.map((item) => {
    const prev = existingByKey.get(`${item.id}:${item.expertRole}`);

    return {
      id: item.id,
      name: prev?.name ?? item.id,
      expertRole: item.expertRole,
      order: item.order,
      messages: prev?.messages ?? [],
      status: prev?.status ?? 'active',
    };
  });
}
